import type { HighlightPiece } from "@/lib/search-highlight"

type SearchResult<Document> = {
  rank?: number
  highlight?: Partial<Record<keyof Document, string | null>> | null
}

export function parseHighlight(highlight: string): HighlightPiece[] {
  if (!highlight) return []

  const parts = highlight.split(/(<mark>.*?<\/mark>)/g)

  const result: HighlightPiece[] = []

  for (const part of parts) {
    if (!part) continue

    if (part.startsWith("<mark>") && part.endsWith("</mark>")) {
      const content = part.slice(6, -7)
      if (content) {
        result.push({ mark: content })
      }
    } else {
      result.push(part)
    }
  }

  return result
}

export function generateSearchHighlighter<Document>(
  searchResult?: SearchResult<Document> | null,
) {
  return (attr: keyof Document, str?: string | null): HighlightPiece[] => {
    const defaultResult = str ? [str] : []
    const highlight = searchResult?.highlight?.[attr]
    if (!highlight) return defaultResult

    return parseHighlight(highlight)
  }
}
